import React, { useEffect, useState } from "react";
import { Layout, Typography, Avatar, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import { BASE_URL } from "./config";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";
const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const Data = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

   const companyId = user?.company_id; // company ID from user
  console.log("Company ID123:", companyId)

  // Fetch data when user is available
  useEffect(() => {
    if (!user) return;

    setLoading(true);
    fetch(`${BASE_URL}/slots.php?action=list&companyId=${companyId}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          // Group slots by date + company_id
          const grouped = Object.values(
            res.data.reduce((acc, item) => {
              const key = `${item.date}_${item.company_id}`;
              if (!acc[key]) {
                acc[key] = {
                  date: item.date,
                  company_id: item.company_id,
                  slots: [],
                  status: item.status,
                };
              }
              acc[key].slots.push(item.slot);
              return acc;
            }, {})
          );

          setData(grouped);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [user]);

  return (
    <Layout style={{ minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
     <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="lg"
          collapsedWidth="80"
        >
          <Sidebar collapsed={collapsed} user={user} />
        </Sider>

      <Layout>
        <HeaderBar title="Slots Table" />

        <Content style={{ margin: 24 }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <Spin size="large" tip="Loading slots..." />
            </div>
          ) : (
            <div
              style={{
                maxHeight: "80vh",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: 8,
                padding: 10,
                background: "#f9f9f9",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                }}
              >
                <thead
                  style={{
                    background: "#343a40",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Date</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Company ID</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Slots</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center", padding: "10px" }}>
                        No slots found
                      </td>
                    </tr>
                  ) : (
                    data.map((row, idx) => (
                      <tr
                        key={idx}
                        style={{
                          background: idx % 2 === 0 ? "#fff" : "#f2f2f2",
                        }}
                      >
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{row.date}</td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{row.company_id}</td>
                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{row.slots.join(", ")}</td>
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            color: row.status === "1" ? "green" : "red",
                          }}
                        >
                          {row.status === "1" ? "Active" : "Inactive"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Content>
        <Footer user={user}/>
      </Layout>
    </Layout>
  );
};

export default Data;
